import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

const password = 'gcare123';

function RmOnline() {
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (inputValue === password) {
        window.location.href = 'https://www.rmmonline.co.uk/?implicit-login=true';
        return;
      }
      setError('Incorrect password. Please try again.');
      setInputValue('');
    },
    [inputValue]
  );

  return (
    <>
      <Helmet>
        <title>Royal Marsden Online | Whitstable House</title>
        <meta
          name="description"
          content="Access Royal Marsden Online from Whitstable House. Enter your password to continue."
        />
        <link rel="canonical" href="https://www.whitstable.house/rmonline/" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section rmonline-page">
            <div className="rmonline-container">
              <div className="phone-calls-gate rmonline-gate">
                <p className="phone-calls-gate__intro">Enter your password to continue</p>
                <form className="phone-calls-form" onSubmit={handleSubmit} noValidate>
                  <label htmlFor="rmonline-password" className="phone-calls-form__label">
                    Password
                  </label>
                  <input
                    id="rmonline-password"
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    className="phone-calls-form__input"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    aria-invalid={error ? true : undefined}
                    aria-describedby={error ? 'rmonline-error' : undefined}
                  />
                  {error && (
                    <p id="rmonline-error" className="phone-calls-form__error" role="alert">
                      {error}
                    </p>
                  )}
                  <button type="submit" className="phone-calls-form__submit">
                    Enter
                  </button>
                </form>
              </div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Whitstable House <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
                <p>Copyright © Whitstable House</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default RmOnline;
